/**
 * This page redirects to the Ashby listing page.
 *
 * If the job no longer exists, it redirects to the jobs page.
 *
 */
import { getJobRedirectUrl } from '~/lib/jobs'


interface Params {
  params: {
    id: string
  }
}

export const getServerSideProps = async ({ params: { id } }: Params) => {
  return {
    redirect: {
      destination: getJobRedirectUrl(id, 'detail'),
      permanent: false,
    },
  }
}

export default function() {
  throw new Error('This page should not be rendered')
}
